import type {
  EnvironmentId,
  PullRequestRef,
  PullRequestListInput,
  PullRequestListStatsInput,
} from "@afar-research/contracts";

export type PullRequestInvalidationTarget = PullRequestRef & {
  readonly partitions?: ReadonlyArray<"summary" | "timeline" | "code" | "list" | "statistics">;
  readonly environmentId: EnvironmentId;
};
const listeners = new Set<(target: PullRequestInvalidationTarget) => void>();
export function subscribePullRequestInvalidation(
  listener: (target: PullRequestInvalidationTarget) => void,
) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
export function invalidatePullRequest(target: PullRequestInvalidationTarget) {
  for (const listener of listeners) listener(target);
}

export function affectsPullRequestList(
  input: PullRequestListInput,
  changed: PullRequestInvalidationTarget,
) {
  if (changed.partitions && !changed.partitions.includes("list")) return false;
  return input.projectIds === undefined || input.projectIds.includes(changed.projectId);
}
export function affectsPullRequestStatistics(
  input: PullRequestListStatsInput,
  changed: PullRequestInvalidationTarget,
) {
  if (changed.partitions && !changed.partitions.includes("statistics")) return false;
  return input.refs.some(
    (ref) =>
      ref.projectId === changed.projectId &&
      ref.repository === changed.repository &&
      ref.number === changed.number,
  );
}
